import { render, staticRenderFns } from "./ofertasEmpleos.vue?vue&type=template&id=d83f9786&scoped=true"
import script from "./ofertasEmpleos.vue?vue&type=script&lang=js"
export * from "./ofertasEmpleos.vue?vue&type=script&lang=js"
import style0 from "./ofertasEmpleos.vue?vue&type=style&index=0&id=d83f9786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83f9786",
  null
  
)

export default component.exports